var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"lg":"5","md":"6"}},[_c('auto-form',{attrs:{"origin":"define/source/categorias"},model:{value:(_vm.currentID),callback:function ($$v) {_vm.currentID=$$v},expression:"currentID"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }